import React, { FC, useMemo } from 'react';
import { Route, useLocation, Switch, useRouteMatch } from 'react-router-dom';
import PublicRoute from '../components/common/router/PublicRoute';
import StepTemplatePage from './on-boarding/StepTemplatePage';

const StepNamePage = React.lazy(() => import(/* webpackChunkName: "StepNamePage" */ './on-boarding/StepNamePage'));

const OnBoardingPage: FC = () => {
    const location = useLocation();
    const { path } = useRouteMatch();
    const isFullWidth = useMemo(() => {
        if (location.pathname === '/getstarted/template') return true;
        return false;
    }, [location.pathname]);
    const outlet = (
        <Switch>
            <Route
                exact
                path={path}
                render={() => (
                    <PublicRoute>
                        <StepNamePage />
                    </PublicRoute>
                )}
            />
            <Route
                exact
                path={`${path}/template`}
                render={() => (
                    <PublicRoute>
                        <StepTemplatePage />
                    </PublicRoute>
                )}
            />
        </Switch>
    );
    return isFullWidth ? (
        outlet
    ) : (
        <div className="flex justify-center flex-auto  bg-gradient-wide">
            <div className={`flex flex-col flex-auto overflow-y-auto p-32 sm:p-0 sm:justify-center grow sm:max-w-550`}>
                {outlet}
            </div>
        </div>
    );
};
export default OnBoardingPage;
